import React from "react";
import { useNavigate } from "react-router-dom";

export default function Privacy() {
    const navigate = useNavigate();

    return (
        <main
            style={{
                padding: "60px 40px",
                maxWidth: "900px",
                margin: "70px auto",
                lineHeight: "1.7"
            }}
        >
            <h1>Privacy Policy</h1>
            <p><strong>Effective Date:</strong> October 4, 2025</p>

            <p>
                Southern Alberta Regional Council Canada, Triskelions Grand Fraternity
                and Sorority ("we", "our", or "us") respects the privacy of its members
                and visitors.
            </p>

            <p>
                This Privacy Policy explains how information is collected, used, and protected
                when using our website and internal systems, including the Online Voting System (OVS).
            </p>

            <h3>1. Information We Collect</h3>
            <p>We may collect and process the following information:</p>
            <ul>
                <li>Member identification and profile details, including name, alias, batch, chapter, membership or primary ID, council, birthday/survive date, contact details, and profile photo</li>
                <li>Account details, including username, role, linked member ID, email address, mobile number, account status, password-change status, and securely hashed passwords or temporary password reset hashes</li>
                <li>Login and security records, including failed login attempts, lockout timestamps, authentication tokens, and administrative access checks</li>
                <li>Online Voting System information, including election records, candidate selections, voter name, primary ID, mobile number, email address, confirmation code, vote submission time, and duplicate-voting checks</li>
                <li>Voting verification records, including email verification codes and expiry times used before a vote is submitted</li>
                <li>Uploaded or submitted content, including profile photos, chairman photos, reports, announcement media, post feed photos or videos, comments, replies, reactions, and comment attachments</li>
                <li>Calendar and event response information, including attendance status, comments, and response timestamps</li>
                <li>Contact form submissions, including name, email address, phone number, and message</li>
                <li>System and audit data, including browser/request information, timestamps, and network address information used for security, fraud detection, and troubleshooting</li>
            </ul>

            <h3>2. Use of Information</h3>
            <p>Collected information is used for:</p>
            <ul>
                <li>Member authentication, account management, password reset, and access control</li>
                <li>Maintaining member profiles, directories, photos, reports, announcements, post feed content, and calendar responses</li>
                <li>Sending verification codes, temporary password messages, contact form messages, election notices, and vote confirmation emails</li>
                <li>Conducting secure and fair online elections, preventing duplicate voting, confirming voter eligibility, issuing vote receipts, and supporting election audits</li>
                <li>Generating election results, participation summaries, administrative reports, and system integrity reviews</li>
                <li>Protecting the website and internal systems from unauthorized access, abuse, file misuse, spam, and automated activity</li>
            </ul>
            <p>
                Vote results are counted by candidate. Voter-identifying information may be retained with vote records
                where required for duplicate-voting prevention, receipt verification, election administration, and audit purposes.
            </p>

            <h3>3. Data Protection</h3>
            <p>
                We implement reasonable technical and organizational safeguards to protect data
                against unauthorized access, alteration, disclosure, or destruction. These safeguards
                include password hashing, role-based access controls, authentication tokens, security
                headers, file upload restrictions, login attempt limits, and controlled administrative access.
            </p>

            <h3>4. Cookies, Tokens, and Local Storage</h3>
            <p>
                We may use authentication cookies, browser local storage, and session storage to maintain
                login state, remember the current view or tab, support OVS access state, show announcements,
                and improve the user experience. No advertising or third-party tracking cookies are used.
            </p>

            <h3>5. Email and Service Providers</h3>
            <p>
                We may use an email service provider to send contact form messages, password reset messages,
                voting verification codes, and vote confirmation emails. Information sent through these
                messages is used only for the related system function.
            </p>

            <h3>6. Uploaded Files and Public Content</h3>
            <p>
                Some uploaded or submitted content may be visible to authorized members or, where the website
                makes it public, to visitors. This may include reports, announcements, public calendar items,
                member profile photos, post feed content, comments, replies, reactions, and media attachments.
            </p>

            <h3>7. Data Retention</h3>
            <p>
                Records are retained for as long as necessary to operate the website, maintain member records,
                administer elections, verify results, resolve disputes, perform audits, and meet organizational
                requirements. Some post feed content may be automatically removed after the configured retention period.
            </p>

            <h3>8. Your Rights</h3>
            <p>
                Members may request access to or correction of their personal information by
                contacting the system administrator.
            </p>

            <h3>9. Changes to This Policy</h3>
            <p>
                This policy may be updated periodically. Continued use of the system indicates
                acceptance of the updated policy.
            </p>
            <h3>10. IP Address Handling & Privacy</h3>

            <p>
                When a vote is submitted, the system may process the voter's network address to create
                a <strong>cryptographic IP hash</strong> for election security and duplicate-activity review.
            </p>

            <ul>
                <li>IP hashes are generated with a salted one-way HMAC-SHA256 function when the IP hash salt is configured</li>
                <li>The vote record stores the generated IP hash, not the raw network address, for fraud detection and audit support</li>
                <li>If IP hashing is not configured, the system stores a blank IP hash value instead of creating one</li>
                <li>Network address information may be processed by the server and may appear in operational or troubleshooting logs</li>
                <li>IP hash information is used only for security review, duplicate or automated voting detection, election integrity, and audit purposes</li>
                <li>Voting metadata is retained only for the period necessary to verify results, conduct audits, resolve disputes, and administer the election</li>
            </ul>

            <p>
                This approach supports data-minimization, privacy-by-design, and security-by-default principles while
                preserving the records needed to operate and audit the Online Voting System.
            </p>
            <h3>Contact</h3>
            <p>
                For questions regarding this policy, please contact the Council Administrator.
            </p>

            {/* ✅ CLOSE BUTTON */}
            <div style={{ marginTop: "40px", textAlign: "center" }}>
                <button
                    onClick={() => navigate("/")}
                    onMouseEnter={(e) => {
                        e.target.style.background = "rgba(218, 165, 32, 0.15)";
                        e.target.style.color = "#ffd700";
                        e.target.style.boxShadow = "0 0 10px rgba(218,165,32,0.4)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = "transparent";
                        e.target.style.color = "goldenrod";
                        e.target.style.boxShadow = "none";
                    }}
                    style={{
                        padding: "10px 28px",
                        background: "transparent",
                        color: "goldenrod",
                        border: "1px solid goldenrod",
                        borderRadius: "6px",
                        fontSize: "0.95rem",
                        cursor: "pointer",
                        transition: "all 0.25s ease"
                    }}
                >
                    Close
                </button>
            </div>
        </main>
    );
}
